/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Col, Row, Image, Typography, message, Spin } from "antd";
import { useDropzone } from "react-dropzone";
import { useSelector } from "react-redux";
import { uploadMedia } from "api";
import { LoadingOutlined } from "@ant-design/icons";

const UploadPreview = ({ form, component, item }) => {
  const [image, setImage] = useState({
    url: null,
    preview: false,
    loading: false,
  });
  const formValues = useSelector((state) => state.formValues);
  const selectedLanguage = useSelector((state) => state.selectedLanguage);

  // useEffect(() => {
  //   let url = null;
  //   if(component === "customer_data"){
  //     url = formValues[component][item.name]
  //   }else{
  //     url = formValues[item.name]
  //   }
  //   if (url) {
  //     setImage({
  //       show: true,
  //       file: {
  //         preview: url,
  //       },
  //     });
  //   }
  // }, []);

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    minSize: 0,
    maxSize: 5242880,
    maxFiles: 1,
    onDrop: (acceptedFiles) => {
      acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      );

      if (acceptedFiles.length > 0) {
        // setImage({
        //   ...image,
        //   file: acceptedFiles[0],
        //   show: true,
        // });

        uploadImage(acceptedFiles[0]);
      }
    },
  });

  // useEffect(
  //   () => () => {
  //     // Make sure to revoke the data uris to avoid memory leaks
  //     if (image.file) {
  //       URL.revokeObjectURL(image.file.preview);
  //     }
  //   },
  //   [image.file]
  // );

  // const onUpload = (file) => {

  // let reader = new FileReader();
  // reader.readAsDataURL(file);
  // reader.onload = () => {
  //   // console.log(reader.result);
  //   if (component === "customer_data") {
  //     form.setFieldsValue({
  //       [component]: {
  //         [item.name]: reader.result,
  //       },
  //     });
  //   } else {
  //     form.setFieldsValue({
  //       [item.name]: reader.result,
  //     });
  //   }
  // };
  // reader.onerror = (error) => {
  //   console.log(error);
  // };
  // };

  useEffect(() => {
    let url = null;
    if (component === "customer_data") {
      url = formValues.customer_data[item.name];
    } else {
      url = formValues[item.name];
    }

    if (url) {
      setImage({
        ...image,
        preview: true,
        url,
      });
    }
  }, [formValues]);

  const uploadImage = (e) => {
    let imageState = { ...image, loading: true, preview: true };

    setImage(imageState);
    const formData = new FormData();

    const reqName = `${item.name}-->${
      component === "customer_data" ? "c" : "f"
    }`;
    formData.append(reqName, e);
    uploadMedia({ data: formData })
      .then((res) => {
        const { data = [] } = res || {};
        const url = data[0][reqName] || "";
        if (url && url !== "") {
          if (component === "customer_data") {
            form.setFieldsValue({
              [component]: {
                [item.name]: url,
              },
            });
          } else {
            form.setFieldsValue({
              [item.name]: url,
            });
          }
          imageState.url = url;
        } else {
          throw Error("ERROR! Server dont sent url");
        }
      })
      .catch((err) => {
        imageState.preview = false;
        message.error("ERROR! Image upload failed!");
        console.error(err);
      })
      .finally(() => {
        imageState.loading = false;
        setImage({ ...imageState });
      });
  };

  return (
    <Row style={{ width: "100%" }} justify="center" gutter={[0, 8]}>
      <Col xs={24}>
        <div className={"upload_preview"} {...getRootProps()}>
          <div className="d-flex flex-column justify-content-center align-items-center left-to-right-holder upload_preview_form">
            {!item.disable && <input {...getInputProps()} />}
            <Typography.Text className="custom-input-placeholder">
              {item.placeholder[selectedLanguage]}
            </Typography.Text>
          </div>
          {image.preview && (
            <div className="upload_preview_block">
              {image.loading ? (
                <Spin indicator={<LoadingOutlined spin />} />
              ) : (
                <img className="upload_image" src={image.url} />
              )}
            </div>
          )}
        </div>
      </Col>
      {/* {image?.file?.preview && (
        <Col xs={24} style={{ display: "flex", justifyContent: "center" }}>
          
        </Col>
      )} */}
    </Row>
  );
};

export default UploadPreview;
